(function () {
  const links = document.querySelectorAll('.js-link');

  links.forEach((link) => {
    link.addEventListener('click', e => {
      e.stopPropagation();
      e.preventDefault();
      location.href = link.dataset.href;
    })
  });

}());